'use strict';

const icons = {
  error: 'notification',
  success: 'checkmark',
  warning: 'warning',
  info: 'info'
};

const Message = {
  show (text, timeout = 6000, color = 'error') {
    let message = document.getElementById('app-message');
    message.querySelector('i').className = `icon-${icons[color]}`;
    message.querySelector('span').textContent = text;
    message.style.display = 'block';
    message.classList.remove('zoomOut');
    message.classList.add('bounceInDown');
    message.classList.remove('error');
    message.classList.remove('success');
    message.classList.remove('warning');
    message.classList.remove('info');
    message.classList.add(color);

    setTimeout(this.hide, timeout);
  },
  success (text, timeout = 6000) {
    this.show(text, timeout, 'success');
  },
  error (text, timeout = 6000) {
    this.show(text, timeout, 'error');
  },
  info (text, timeout = 6000) {
    this.show(text, timeout, 'info');
  },
  warning (text, timeout = 6000) {
    this.show(text, timeout, 'warning');
  },
  hide () {
    let message = document.getElementById('app-message');
    message.classList.remove('bounceInDown');
    message.classList.add('zoomOut');
  }
};

export default {
  install: Vue => {
    Vue.prototype.$message = Message;
  }
};



// WEBPACK FOOTER //
// ./src/lib/message.js